module.exports = __webpack_public_path__ + "static/media/home-shape.7b18f102.svg";